var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('MySection',{attrs:{"name":"projects","title":"My works","goBack":"true"}},[_vm._v("\n  Test test\n")])}
var staticRenderFns = []

export { render, staticRenderFns }